import { forwardRef } from 'react';

export const Card = forwardRef(({ children, className = '', ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={`rounded-2xl border border-neutral-200/80 dark:border-neutral-700/80 bg-white/92 dark:bg-neutral-900/92 p-4 sm:p-6 shadow-[0_8px_20px_-14px_rgba(15,23,42,0.45),0_2px_6px_rgba(15,23,42,0.08)] dark:shadow-[0_14px_28px_-16px_rgba(0,0,0,0.55)] hover:shadow-[0_16px_28px_-14px_rgba(15,23,42,0.38)] dark:hover:shadow-[0_18px_30px_-14px_rgba(0,0,0,0.62)] transition-all duration-300 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export const CardHeader = ({ children, className = '' }) => {
  return (
    <div className={`mb-3 sm:mb-4 ${className}`}>
      {children}
    </div>
  );
};

export const CardContent = ({ children, className = '' }) => {
  return (
    <div className={`${className}`}>
      {children}
    </div>
  );
};

export const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-neutral-200/50 dark:border-neutral-700/50 ${className}`}>
      {children}
    </div>
  );
};
